import {TimelineTimeAxisScaleType} from 'vis-timeline/esnext';
import { ScaleType } from '../../scale.type';

const MACHINES_SCALE_SETTINGS: Map<TimelineTimeAxisScaleType, ScaleType> = new Map();
MACHINES_SCALE_SETTINGS.set('day', {
    columnWidth: 120,
    columnCount: 150,
    name: 'Tagesansicht',
    iconName: 'calendar-today',
    buttonColor: 'green'
});
// @ts-ignore
MACHINES_SCALE_SETTINGS.set('week', {
    columnWidth: 200,
    columnCount: 20,
    name: 'Wochenansicht',
    iconName: 'calendar-week',
    buttonColor: 'indigo'
});
MACHINES_SCALE_SETTINGS.set('month', {
    columnWidth: 900,
    columnCount: 12,
    name: 'Monatsansicht',
    iconName: 'calendar-month',
    buttonColor: 'red'
});

export {MACHINES_SCALE_SETTINGS};
